<template>
  <v-main>
    <v-container fluid>
      <v-btn
        fab
        x-small
        class="mx-2 mb-2"
        color="white"
        @click="$router.back()"
      >
        <v-icon light>mdi-arrow-left</v-icon>
      </v-btn>

      <v-card elevation="12" class="mt-2" rounded="xl">
        <v-row class="mx-4 mt-5 pa-4">
          <!-- Left Column -->
          <v-col cols="12" md="6" class="pa-0 pr-md-6">
            <v-row class="my-2">
              <v-col class="pa-0">
                <h5 class="text-h6" align="left">Date</h5>
                <v-text-field
                  hide-details=""
                  solo
                  dense
                  rounded
                  v-model="form.date"
                  readonly
                  outlined
                  class="blue--text"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row class="my-2">
              <v-col class="pa-0">
                <h5 class="text-h6" align="left">Site Name</h5>
                <v-select
                  solo
                  hide-details=""
                  dense
                  rounded
                  v-model="form.site_id"
                  :items="sites"
                  label="Client"
                ></v-select>
              </v-col>
            </v-row>
            <v-row class="my-2">
              <v-col class="pa-0">
                <h5 class="text-h6" align="left">Site Location</h5>
                <v-text-field
                  hide-details=""
                  solo
                  dense
                  rounded
                  v-model="form.site_location"
                  placeholder="Site Location"
                  outlined
                  class="blue--text"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row class="my-2">
              <v-col class="pa-0">
                <h5 class="text-h6" align="left">Total Manpower</h5>
                <v-text-field
                  hide-details=""
                  solo
                  dense
                  rounded
                  v-model.number="form.total_manpower"
                  type="number"
                  placeholder="Total Manpower"
                  outlined
                  class="blue--text"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row class="my-2">
              <v-col class="pa-0">
                <h5 class="text-h6" align="left">Total Present</h5>
                <v-text-field
                  hide-details=""
                  solo
                  dense
                  rounded
                  v-model.number="form.total_present"
                  type="number"
                  placeholder="Total Present"
                  outlined
                  class="blue--text"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row class="my-2">
              <v-col class="pa-0">
                <h5 class="text-h6" align="left">Shortage Manpower</h5>
                <v-text-field
                  hide-details=""
                  solo
                  dense
                  rounded
                  v-model.number="form.shortage_manpower"
                  type="number"
                  placeholder="Shortage Manpower"
                  outlined
                  class="blue--text"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row class="my-2">
              <v-col class="pa-0">
                <h5 class="text-h6" align="left">Total HK Boys</h5>
                <v-text-field
                  hide-details=""
                  solo
                  dense
                  rounded
                  v-model.number="form.total_hk_boys"
                  type="number"
                  placeholder="Total HK Boys"
                  outlined
                  class="blue--text"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row class="my-2">
              <v-col class="pa-0">
                <h5 class="text-h6" align="left">Total CM</h5>
                <v-text-field
                  hide-details=""
                  solo
                  dense
                  rounded
                  v-model.number="form.total_cm"
                  type="number"
                  placeholder="Total CM"
                  outlined
                  class="blue--text"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row class="my-2">
              <v-col class="pa-0">
                <h5 class="text-h6" align="left">Total Pantry Boy</h5>
                <v-text-field
                  hide-details=""
                  solo
                  dense
                  rounded
                  v-model.number="form.total_pantry_boy"
                  type="number"
                  placeholder="Total Pantry Boy"
                  outlined
                  class="blue--text"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row class="my-2">
              <v-col class="pa-0">
                <h5 class="text-h6" align="left">Total Office Boy</h5>
                <v-text-field
                  hide-details=""
                  solo
                  dense
                  rounded
                  v-model.number="form.total_office_boy"
                  type="number"
                  placeholder="Total Office Boy"
                  outlined
                  class="blue--text"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row class="my-2">
              <v-col class="pa-0">
                <h5 class="text-h6" align="left">Total Supervisor</h5>
                <v-text-field
                  hide-details=""
                  solo
                  dense
                  rounded
                  v-model.number="form.total_supervisor"
                  type="number"
                  placeholder="Total Supervisor"
                  outlined
                  class="blue--text"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row class="my-2">
              <v-col class="pa-0">
                <h5 class="text-h6" align="left">Total Reliever</h5>
                <v-text-field
                  hide-details=""
                  solo
                  dense
                  rounded
                  v-model.number="form.total_reliever"
                  type="number"
                  placeholder="Total Reliever"
                  outlined
                  class="blue--text"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row class="my-2">
              <v-col class="pa-0">
                <h5 class="text-h6" align="left">Absent Name</h5>
                <v-text-field
                  hide-details=""
                  solo
                  dense
                  rounded
                  v-model="form.absent_name"
                  placeholder="Absent Name"
                  outlined
                  class="blue--text"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row class="my-2">
              <v-col class="pa-0">
                <h5 class="text-h6" align="left">Staff Work</h5>
                <v-textarea
                  outlined
                  label="Staff Work"
                  v-model="form.staff_work"
                ></v-textarea>
              </v-col>
            </v-row>
            <v-row class="my-2">
              <v-col class="pa-0">
                <h5 class="text-h6" align="left">Client Visit</h5>
                <v-textarea
                  outlined
                  label="Client Visit"
                  v-model="form.client_visit"
                ></v-textarea>
              </v-col>
            </v-row>
            <v-row class="my-2">
              <v-col class="pa-0">
                <h5 class="text-h6" align="left">New Joining Details</h5>
                <v-textarea
                  outlined
                  label="New Joining Details"
                  v-model="form.new_joining_details"
                ></v-textarea>
              </v-col>
            </v-row>
            <v-row class="my-2">
              <v-col class="pa-0">
                <h5 class="text-h6" align="left">Is Active</h5>
                <v-checkbox v-model="form.is_active"></v-checkbox>
              </v-col>
            </v-row>
            <!-- <v-row class="my-2">
              
            </v-row> -->
          </v-col>

          <!-- Right Column -->
          <v-col cols="12" md="6" class="pa-0 pl-md-4">
            <v-row class="my-2">
              <v-col class="pa-0">
                <h5 class="text-h6" align="left">Monday Agenda</h5>
                <v-text-field
                  hide-details=""
                  solo
                  dense
                  rounded
                  v-model="form.monday_agenda"
                  placeholder="Monday Agenda"
                  outlined
                  class="blue--text"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row class="my-2">
              <v-col class="pa-0">
                <h5 class="text-h6" align="left">Tuesday Agenda</h5>
                <v-text-field
                  hide-details=""
                  solo
                  dense
                  rounded
                  v-model="form.tuesday_agenda"
                  placeholder="Tuesday Agenda"
                  outlined
                  class="blue--text"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row class="my-2">
              <v-col class="pa-0">
                <h5 class="text-h6" align="left">Wednesday Agenda</h5>
                <v-text-field
                  hide-details=""
                  solo
                  dense
                  rounded
                  v-model="form.wednesday_agenda"
                  placeholder="Wednesday Agenda"
                  outlined
                  class="blue--text"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row class="my-2">
              <v-col class="pa-0">
                <h5 class="text-h6" align="left">Thursday Agenda</h5>
                <v-text-field
                  hide-details=""
                  solo
                  dense
                  rounded
                  v-model="form.thursday_agenda"
                  placeholder="Thursday Agenda"
                  outlined
                  class="blue--text"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row class="my-2">
              <v-col class="pa-0">
                <h5 class="text-h6" align="left">Friday Agenda</h5>
                <v-text-field
                  hide-details=""
                  solo
                  dense
                  rounded
                  v-model="form.friday_agenda"
                  placeholder="Friday Agenda"
                  outlined
                  class="blue--text"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row class="my-2">
              <v-col class="pa-0">
                <h5 class="text-h6" align="left">Saturday Agenda</h5>
                <v-text-field
                  hide-details=""
                  solo
                  dense
                  rounded
                  v-model="form.saturday_agenda"
                  placeholder="Saturday Agenda"
                  outlined
                  class="blue--text"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row class="my-2">
              <v-col class="pa-0">
                <h5 class="text-h6" align="left">Sunday Agenda</h5>
                <v-text-field
                  hide-details=""
                  solo
                  dense
                  rounded
                  v-model="form.sunday_agenda"
                  placeholder="Sunday Agenda"
                  outlined
                  class="blue--text"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row class="my-2">
              <v-col class="pa-0">
                <h5 class="text-h6" align="left">Supervisor Name</h5>
                <v-text-field
                  hide-details=""
                  solo
                  dense
                  rounded
                  v-model="form.supervisor_name"
                  placeholder="Supervisor Name"
                  outlined
                  class="blue--text"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row class="my-2">
              <v-col class="pa-0">
                <h5 class="text-h6" align="left">Site In Time</h5>
                <v-text-field
                  v-model="form.site_in_time"
                  placeholder="Select Time"
                  append-icon="mdi-clock-outline"
                  readonly
                  solo
                  dense
                  rounded
                  outlined
                  class="blue--text"
                  @click="openTimePicker('site_in_time')"
                ></v-text-field>
                <v-dialog
                  v-model="timePickerDialog.site_in_time"
                  max-width="290"
                >
                  <v-time-picker
                    v-model="form.site_in_time"
                    format="12hr"
                    @click:minute="timePickerDialog.site_in_time = false"
                  ></v-time-picker>
                </v-dialog>
              </v-col>
            </v-row>
            <v-row class="my-2">
              <v-col class="pa-0">
                <h5 class="text-h6" align="left">Site Out Time</h5>
                <v-text-field
                  v-model="form.site_out_time"
                  placeholder="Select Time"
                  append-icon="mdi-clock-outline"
                  readonly
                  solo
                  dense
                  rounded
                  outlined
                  class="blue--text"
                  @click="openTimePicker('site_out_time')"
                ></v-text-field>
                <v-dialog
                  v-model="timePickerDialog.site_out_time"
                  max-width="290"
                >
                  <v-time-picker
                    v-model="form.site_out_time"
                    format="12hr"
                    @click:minute="timePickerDialog.site_out_time = false"
                  ></v-time-picker>
                </v-dialog>
              </v-col>
            </v-row>
            <v-row class="my-2">
              <v-col class="pa-0">
                <h5 class="text-h6" align="left">Signature</h5>
                <input
                  type="file"
                  ref="signature"
                  accept="image/*"
                  style="min-width: 140px"
                />
              </v-col>
            </v-row>
            <v-row class="my-2">
              <v-col class="pa-0">
                <h5 class="text-h6" align="left">Image 1</h5>
                <input
                  type="file"
                  ref="image_1"
                  accept="image/*"
                  style="min-width: 140px"
                />
              </v-col>
            </v-row>
            <v-row class="my-2">
              <v-col class="pa-0">
                <h5 class="text-h6" align="left">Image 2</h5>
                <input
                  type="file"
                  ref="image_2"
                  accept="image/*"
                  style="min-width: 140px"
                />
              </v-col>
            </v-row>
            <v-row class="my-2">
              <v-col class="pa-0">
                <h5 class="text-h6" align="left">Image 3</h5>
                <input
                  type="file"
                  ref="image_3"
                  accept="image/*"
                  style="min-width: 140px"
                />
              </v-col>
            </v-row>
            <v-row class="my-2">
              <v-col class="pa-0">
                <h5 class="text-h6" align="left">Image 4</h5>
                <input
                  type="file"
                  ref="image_4"
                  accept="image/*"
                  style="min-width: 140px"
                />
              </v-col>
            </v-row>
            <v-row class="my-2">
              <v-col class="pa-0">
                <h5 class="text-h6" align="left">Image 5</h5>
                <input
                  type="file"
                  ref="image_5"
                  accept="image/*"
                  style="min-width: 140px"
                />
              </v-col>
            </v-row>
            <v-row class="my-2">
              <v-col class="pa-0">
                <h5 class="text-h6" align="left">Image 6</h5>
                <input
                  type="file"
                  ref="image_6"
                  accept="image/*"
                  style="min-width: 140px"
                />
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row justify="center" class="mx-4 my-4 pa-4">
          <v-col align="center">
            <v-btn
              @click="save"
              min-width="200"
              :loading="isLoading"
              color="blue"
              rounded
              max-width="100"
              dark
              >Save Details</v-btn
            >
          </v-col>
        </v-row>
      </v-card>
    </v-container>
    <v-container class="footer-text">
      <v-row justify="center">
        <v-col align="center">
          <h3 class="white--text">We Alliance Sparkle</h3>
          <h4 class="white--text">v 1.0.0</h4>
        </v-col>
      </v-row>
    </v-container>
  </v-main>
</template>

<script>
import axios from "axios";

export default {
  name: "VistingReport",
  data() {
    return {
      form: {
        date: new Date().toISOString().split("T")[0], // Auto-fetch current date (e.g., 2025-06-24)
        site_location: "",
        total_manpower: null,
        total_present: null,
        shortage_manpower: null,
        total_hk_boys: null,
        total_cm: null,
        total_pantry_boy: null,
        total_office_boy: null,
        total_supervisor: null,
        total_reliever: null,
        absent_name: "",
        staff_work: "",
        client_visit: "",
        new_joining_details: "",
        monday_agenda: "",
        tuesday_agenda: "",
        wednesday_agenda: "",
        thursday_agenda: "",
        friday_agenda: "",
        saturday_agenda: "",
        sunday_agenda: "",
        supervisor_name: "",
        site_in_time: null,
        site_out_time: null,
        signature_path: "",
        image_1_path: "",
        image_2_path: "",
        image_3_path: "",
        image_4_path: "",
        image_5_path: "",
        image_6_path: "",
        is_active: true,
      },
      timePickerDialog: {
        site_in_time: false,
        site_out_time: false,
      },

      visit_reports: [],
      sites: [],

      isLoading: false,
    };
  },
  computed: {
    isClient() {
      return this.user?.roles?.[0]?.name === "Client";
    },
  },
  async mounted() {
    await this.getMasters();
    await this.getData();
  },
  methods: {
    openTimePicker(field) {
      this.timePickerDialog[field] = true;
    },
    async getMasters() {
      let masters = await axios.get("visit_reports/masters");
      masters = masters.data.data;
      masters.sites.forEach((site) => {
        this.sites.push({
          id: site.id,
          text: site.name,
          value: site.id,
        });
      });
    },
    async getData() {
      this.isLoading = true;
      let form = await axios.get(
        `/visit_reports/${this.$route.params.visitingId}`
      );
      this.form = form.data.data;
      this.isLoading = false;
    },
  },
};
</script>

<style scoped>
.sticky-column {
  position: sticky;
  left: 0;
  background-color: white; /* Match background color of table header */
  z-index: 1; /* Ensure the fixed column appears above other columns */
}
.sticky-header {
  position: sticky;
  left: 0;
  background-color: white; /* Match background color of table header */
  z-index: 3 !important; /* Ensure the fixed column appears above other columns */
}
</style>
